import script from "./reset-password.vue?vue&type=script&setup=true&lang=js"
export * from "./reset-password.vue?vue&type=script&setup=true&lang=js"

import "./reset-password.vue?vue&type=style&index=0&id=73e5aba2&lang=scss&scoped=true"

import exportComponent from "/root/buildarea/boeingdl-dev-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-73e5aba2"]])

export default __exports__